export default "__VITE_ASSET__nwwXq8XN__"